// Canonical display labels for membership roles, shared across the org switcher,
// Settings, and the invite flow so the same role never shows two different
// labels on different screens.
export const ROLE_LABELS = {
  org_admin: 'Admin',
  landlord: 'Landlord',
  org_member: 'Member',
  tenant: 'Tenant',
};

export function roleLabel(role) {
  return ROLE_LABELS[role] || role;
}
